import moment from 'moment';
import { Box, Heading } from 'native-base';
import { useCallback, useEffect, useState } from 'react';
import { IoFileTray } from 'react-icons/io5';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Label,
  ResponsiveContainer,
} from 'recharts';
import { IQuiz } from '../types/QuizTypes';
import { useTranslation } from 'react-i18next';

export const barColors = [
  '#fece4d',
  '#e5b945',
  '#cba53e',
  '#b29036',
  '#987c2e',
  '#7f6727',
  '#8ad9d5',
  '#5bcac4',
  '#2cbbb3',
  '#13a19a',
  '#0f7d78',
  '#0b5a56',
  '#ccb3c3',
  '#aa819b',
  '#874f72',
  '#651c4a',
  '#51163b',
  '#3d112c',
  '#6ebafa',
  '#63a7e1',
  '#5895c8',
  '#4d82af',
  '#427096',
  '#375d7d',
  '#e7b9a7',
  '#da977b',
  '#ce744f',
  '#c25123',
  '#612812',
  '#491e0d',
  '#a9d2a4',
  '#7dbc77',
  '#52a549',
  '#278f1c',
  '#1f7216',
  '#10390b',
  '#ffb8ef',
  '#fe94e8',
  '#fe71e0',
  '#fe4dd8',
  '#cb3ead',
  '#661f56',
  '#babfe7',
  '#8c94d7',
  '#5e69c7',
  '#303eb7',
  '#17249e',
  '#0d1458',
]
interface StudentReportLearningObjectiveBarChartProps {
  quizReports: IQuiz[];
}

const StudentReportLearningObjectiveBarChart: React.FC<StudentReportLearningObjectiveBarChartProps> = (props) => {
  const [data, setData] = useState<any[]>();
  const [dataKeySet, setDataKeySet] = useState<{ [key: string]: string }>();

  const { t } = useTranslation();


  useEffect(() => {
    // group scores with its learning unit by date
    const dataGroupByDate = props.quizReports.sort((a, b) => (a.learningObjective.code < b.learningObjective.code ? -1 : 1)).reduce<{ [key: string]: any[] }>(
      (groups, item) => {
        const date = moment(item.createdAt).format('L');
        return {
          ...groups,
          [date]: [
            ...(groups[date] || []),
            { [item.learningObjective.code]: item.score * 100 },
          ],
        };
      },
      {}
    );

    // filter out duplicated and non-max score for each learning unit for each date
    let formattedData: any = [];
    Object.keys(dataGroupByDate).forEach((k) => {
      let unitMap: any = {};
      dataGroupByDate[k].forEach((LUScoresMap) => {
        const unit = Object.keys(LUScoresMap)[0];
        if (unitMap[unit] && unitMap[unit] < LUScoresMap[unit]) {
          unitMap[unit] = LUScoresMap[unit];
        }
        if (!unitMap[unit]) {
          unitMap[unit] = LUScoresMap[unit];
        }
      });
      formattedData.push({ createdAt: k, ...unitMap });
    });

    setData(formattedData.sort((a: any, b: any) => a.createdAt < b.createdAt ? -1 : 1));
    console.log(formattedData)

    //get all LU with quizzes and generate unique color for them
    const colorKeys: any = {};
    props.quizReports.map(x => x.learningObjective.code).filter((v, i, a) => a.indexOf(v) === i).forEach((code, i) => {
      colorKeys[code] = barColors[i % barColors.length];
    });
    console.log(Object.values(colorKeys))
    setDataKeySet(colorKeys);
  }, [props.quizReports]);

  return (
    <Box w={"100%"} h="350px" mb={8}>
      <Heading>{t('Learning Objective')}</Heading>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="createdAt" />
          <YAxis>
            <Label value={t("Score")} angle={-90} dx={-15} />
          </YAxis>
          <Tooltip />
          <Legend verticalAlign="bottom" />
          {dataKeySet &&
            Object.keys(dataKeySet).map((key, index) => (
              <Bar key={key} dataKey={key} fill={`${dataKeySet[key]}`} />
            ))}
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default StudentReportLearningObjectiveBarChart;
